export const sampleCourseLisitingSx = {
  modalBox: {
    width: '95%',
    height: '90vh',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    overflow: 'hidden',
  },
  closeBtn: {
    position: 'absolute',
    top: 4,
    right: 2,
    zIndex: 10,
  },
  scrollContainer: {
    height: '100%',
    overflowY: 'auto',
    px: 2,
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 10,
    mx: { xs: 0, sm: 3 },
    mt: 6,
    mb: 3,
    alignItems: { xs: "center", md: "start" },
  },
  imageBox: {
    mb: 2,
    borderRadius: 10,
    overflow: 'hidden',
    width: { xs: '100%', sm: 312, md: 320, lg: 344 },
  },
  imgContainer: {
    borderRadius: '8px 8px 0 0',
    overflow: 'hidden',
    height: 200,
    width: { xl: 375, sm: 390, md: 400, lg: 430 },
  },
  title: {
    fontSize: '18px',
    mt: 2,
    textTransform: 'capitalize',
  },
  avatarBox: {
    display: 'flex',
    gap: 1,
    cursor: 'pointer',
  },
  scheduleButtons: {
    display: 'flex',
    flexDirection: { sm: "row", xs: "column" },
    gap: 2,
  },
  seeScheduleBtn: {
    '&:hover': { cursor: 'pointer' },
    pointerEvents: 'auto',
    textTransform: 'uppercase',
  },
  firstClassGuarantee: {
    fontSize: '14px',
    mt: 1,
    display: 'flex',
    alignItems: 'center',
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    width: { md: "70%" },
    overflow: { md: 'auto' },
    height: { md: '85vh' },
  },
  learningObjectivesTitle: {
    pb: 3,
    fontWeight: 700,
  },
  objectiveItem: {
    display: "flex",
    alignItems: "start",
    width: { lg: "48%" },
  },
  enrollButtonCard: {
        backgroundColor: '#fff',
        color: 'primary.main',
        borderColor: 'primary.main',
        '&:hover': {
            backgroundColor: '#f5f5f5',
            cursor: 'pointer',
        },
    },
  enrollButton: {
    backgroundColor: '#000080',
    borderRadius: '20px',
    fontWeight: 'bold',
    textTransform: 'none',
    px: 4,
    py: 1.5,
    boxShadow: 3,
    '&:hover': {
      backgroundColor: '#000070',
    },
  },
  startDateTypography: {
    fontWeight: 500,
    fontSize: '22px',
  },
  durationTypography: {
    fontWeight: 900,
    pt: 1,
    fontSize: '20px',
  },
  costTypography: {
    fontWeight: 900,
    textAlign: "center",
    pb: 2,
    pt: 3,
    fontSize: '22px',
  },
}
